<template>
  <div class="full-height full-width pb-6">
    <nav class="background-color-white pl-6 py-6">
      <XsNavPill
        v-for="(title, index) in getNavTitles()"
        :key="index"
        :textContent="title"
      />
      <div>
        <a
          class="background-color-seashell font-size-sm nav-button-border-radius pa-2"
          @click="logout"
          >Log Out</a
        >
      </div>
    </nav>
    <LegalLinksNav class="pl-6" />
  </div>
</template>

<script>
import LegalLinksNav from "@/components/Navigation/LegalLinks.vue";
import XsNavPill from "@/components/Navigation/Xs/NavPill.vue";
import { mapState } from "vuex";

export default {
  name: "XsAccountNav",
  components: { LegalLinksNav, XsNavPill },
  computed: {
    ...mapState({
      websiteFormat: (state) =>
        state.store.info.store_info.customization?.website.style
          .website_format ?? "all_items",
    }),
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logout");
      this.$store.commit("cart/CLEAR");
      this.$store.commit("orders/CLEAR");
      this.$store.commit("favorites/CLEAR");
      this.$store.commit("user/CLEAR");
      this.$router.push("/");
    },
    getNavTitles() {
      if (this.websiteFormat === "store_info_rewards") {
        return this.$options.navTitles.filter((t) => {
          return !(t === "About" || t === "Orders");
        });
      }
      return this.$options.navTitles;
    },
  },
  navTitles: ["My Profile", "Orders", "About", "Support"],
};
</script>
